import { useMemo } from "react";
import countriesSubset from "@/data/countries-subset.json";

interface Country {
  value: string;
  label: string;
  latlng: number[];
  region: string;
}

export const useCountries = () => {
  const countries: Country[] = useMemo(
    () =>
      countriesSubset.map((country) => ({
        value: country.cca2,
        label: country.name,
        latlng: country.latlng,
        region: country.region,
      })),
    [],
  );

  const getAll = () => countries;

  const getByValue = (value: string) => {
    return countries.find((item) => item.value === value);
  };

  const getByName = (label: string) => {
    if (!label) return undefined;
    // Try exact match first
    let found = countries.find((item) => item.label === label);
    if (found) return found;
    // Try case-insensitive match
    found = countries.find((item) => item.label.toLowerCase() === label.toLowerCase());
    if (found) return found;
    // Try partial match (contains)
    found = countries.find((item) => 
      item.label.toLowerCase().includes(label.toLowerCase()) ||
      label.toLowerCase().includes(item.label.toLowerCase())
    );
    return found;
  };

  return {
    getAll,
    getByValue,
    getByName,
  };
};

export default useCountries;